export function getHashParam(param, def) {
    const url = new URL(window.location.toString().replace('/#', '/?'));
    if (url.searchParams.get(param) !== null) {
        return JSON.parse(url.searchParams.get(param));
    } else {
        return def;
    }
}

export function setHashParam(param, value) {
    const url = new URL(window.location.toString().replace('/#', '/?'));
    url.searchParams.set(param, value);
    window.location.hash = url.searchParams.toString();
}

export function urlWithHashParam(param, value) {
    const url = new URL(window.location.toString().replace('/#', '/?'));
    url.searchParams.set(param, value);
    return url.href.replace(/\/\?/, '/#');
}
